import { PageTitle } from "@/components/common";
import { AuditSection } from "@/components/admin/UsersSection";

export default function Journal() {
  return (
    <div>
      <PageTitle kicker="Lecture seule" title="Journal du workplace" testId="journal-title" />
      <AuditSection />
    </div>
  );
}
